export default __webpack_public_path__ + "static/lease2-12cfa5c4b944cb22d03b21163acc5651.png";